// src/App.js
import ManagerEvaluationSurvey from "./ManagerEvaluationSurvey";

export default function App() {
  return <ManagerEvaluationSurvey />;
}
